"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttendingAccountingsHttpService = void 0;
const delete_1 = require("../../types/attending-accountings/delete");
const get_list_1 = require("../../types/attending-accountings/get-list");
const set_paid_flags_1 = require("../../types/attending-accountings/set-paid-flags");
const http_service_1 = require("../http.service");
class AttendingAccountingsHttpService extends http_service_1.HttpService {
    constructor(apiUrl) {
        super(`${apiUrl}/attending-accountings`);
    }
    getList(payload) {
        const params = {
            page: String(payload.page),
            per_page: String(payload.per_page),
        };
        if (payload.officeId) {
            params.officeId = payload.officeId;
        }
        if (payload.doctorAttendingId) {
            params.doctorAttendingId = payload.doctorAttendingId;
        }
        if (payload.accountingMonth) {
            params.accountingMonth = String(payload.accountingMonth);
        }
        if (payload.accountingYear) {
            params.accountingYear = String(payload.accountingYear);
        }
        return this.getEntityList('', {
            params,
            schema: get_list_1.getAttendingAccountingsListApiResponseSchema,
        });
    }
    deleteById(id) {
        return this.delete(id, {
            schema: delete_1.deleteAttendingAccountingApiResponseSchema,
        });
    }
    uploadPdf(id, file) {
        return this.post(`${id}/upload-pdf`, {
            body: {
                file: new File([file], 'accounting.pdf', { type: 'application/pdf' }),
            },
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }
    getDownloadPdfUrl(id) {
        return this.get(`${id}/download-pdf`);
    }
    async setPaidFlags(id, payload) {
        const url = this.getApiUrlOf(`${id}/paid-flags`);
        const { data } = await this.fetch(url, {
            method: 'PATCH',
            body: payload,
        });
        return set_paid_flags_1.setAttendingAccountingPaidFlagsApiResponseSchema.parse(data);
    }
}
exports.AttendingAccountingsHttpService = AttendingAccountingsHttpService;
